import PropTypes from 'prop-types'

import { classNames } from '../../helpers'

/**
 * Progressive Disclosure fuer lange Listen.
 *
 * Bewusst kein innerer Scroll-Container: verschachtelte Scrollflaechen fangen
 * das Seiten-Scrolling ab, sind auf macOS ohne sichtbaren Scrollbalken nicht
 * als scrollbar erkennbar und verstecken Treffer vor der Browsersuche.
 * Ein Scroll-Kontext pro View.
 */
const ShowMoreToggle = ({
  expanded,
  onToggle,
  moreLabel,
  lessLabel,
  className
}) => (
  <div className={classNames('mt-2 flex justify-center', className)}>
    <button
      type='button'
      onClick={onToggle}
      aria-expanded={expanded}
      className='rounded-md px-3 py-1.5 text-xs font-medium text-gray-600 transition hover:bg-gray-100 hover:text-primaryBlue focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primaryBlue'
    >
      {expanded ? lessLabel : moreLabel}
    </button>
  </div>
)

ShowMoreToggle.propTypes = {
  expanded: PropTypes.bool.isRequired,
  onToggle: PropTypes.func.isRequired,
  moreLabel: PropTypes.node.isRequired,
  lessLabel: PropTypes.node.isRequired,
  className: PropTypes.string
}

ShowMoreToggle.defaultProps = {
  className: undefined
}

export default ShowMoreToggle
